import { createFileRoute, Outlet } from '@tanstack/react-router';
import { LastWorkspaceResolver } from './-components';

/**
 * Every Pipelines page, so a `/workspaces/last/pipelines/...` link (onboarding emails link to the
 * JavaScript source this way) lands on the current workspace. No `appBundle`: this URL has no
 * `journeys` segment for the resolver to rebuild from.
 */
function PipelinesLayoutRoute() {
  return (
    <LastWorkspaceResolver>
      <Outlet />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines')({
  component: PipelinesLayoutRoute,
});
